import TpJobItem from './TpJobItem';

export default class ReadyForInvoicingTpJobItem extends TpJobItem {
  static FieldsToShowInDataTable() {
    return [
      {
        label: TpJobItem.getSelectedCellHeader,
        orderById: '',
        data: TpJobItem.getSelectedCellContent,
        minWidth: 20,
        rolekey: 'project_edit',
      },
      { label: 'Third Party Job ID', orderById: 'ThirdPartyJobId', data: TpJobItem.idFunction },
      {
        label: 'Source',
        orderById: 'ThirdPartySource',
        data: 'ThirdPartySource',
        minWidth: 50,
      },
      {
        label: 'Survey',
        orderById: 'TpSurveyName',
        data: TpJobItem.getSurveyNameAndIdCellContent,
        minWidth: 50,
      },
      {
        label: 'Location',
        orderById: 'ThirdPartyLocationName',
        data: 'ThirdPartyLocationName',
        minWidth: 50,
      },
      {
        label: 'Campaign',
        orderById: 'CampaignName',
        data: 'CampaignName',
        minWidth: 50,
      },
      {
        label: 'Ad-Hoc Invoice Group',
        orderById: 'AdHocInvoiceGroup',
        data: 'AdHocInvoiceGroup',
        minWidth: 50,
      },
      {
        label: 'Client Fee Total',
        orderById: 'ClientFeeTotalWithSymbol',
        data: 'ClientFeeTotalWithSymbol',
      },
      {
        label: 'Reimb. Total',
        orderById: 'ReimbTotalExchangedWithSymbol',
        data: 'ReimbTotalExchangedWithSymbol',
      },
      {
        label: 'Fieldwork Office',
        orderById: 'FieldworkOfficeName',
        data: 'FieldworkOfficeName',
        minWidth: 50,
      },
      { label: 'FW Fee', orderById: 'FieldworkFeeWithSymbol', data: 'FieldworkFeeWithSymbol', minWidth: 80 },
      { label: 'Eval Fee Total', orderById: 'EvalFeeTotal', data: 'EvalFeeTotal', minWidth: 80 },
      { label: 'Eval Reimb. Total', orderById: 'EvalReimbTotal', data: 'EvalReimbursementTotal', minWidth: 80 },
      {
        label: 'Evaluator',
        orderById: 'TpEvaluatorFullName',
        data: 'TpEvaluatorFullName',
        minWidth: 50,
      },
      {
        label: 'Status',
        orderById: 'ThirdPartyJobStatus',
        data: TpJobItem.getStatusCellWarningContent,
        minWidth: 30,
      },
      {
        label: 'Completed On',
        orderById: 'JobDate',
        data: 'JobDate',
        minWidth: 50,
      },
      {
        label: 'Country',
        orderById: 'ThirdPartyLocationCountry',
        data: 'ThirdPartyLocationCountry',
        minWidth: 50,
      },
    ];
  }
}
